var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "session-recorder ui-elevation-1 panel" },
    [
      _c(
        "ui-select",
        {
          staticClass: "session-recorder__source-type-select",
          attrs: { label: "Source" },
          on: { select: _vm.setDefaultSourceType },
          model: {
            value: _vm.sourceType,
            callback: function ($$v) {
              _vm.sourceType = $$v
            },
            expression: "sourceType",
          },
        },
        _vm._l(_vm.sourceTypeList, function (sourceItem) {
          return _c("ui-select-item", {
            key: sourceItem.key,
            attrs: {
              disabled: sourceItem.key === "webrtc" && !_vm.hasWebRtc,
              label: sourceItem.label,
              value: sourceItem.key,
            },
          })
        }),
        1
      ),
      _vm._v(" "),
      _vm.streaming && _vm.sourceType !== "rtmp"
        ? _c("ui-switch", {
            staticClass: "session-recorder__toggle-streaming",
            attrs: {
              label: "" + (_vm.enableStreaming ? "Stream on" : "Stream off"),
              large: "",
              tooltip: "OFF=Record only / ON=Record and stream",
            },
            on: { change: _vm.toggleStreaming },
            model: {
              value: _vm.enableStreaming,
              callback: function ($$v) {
                _vm.enableStreaming = $$v
              },
              expression: "enableStreaming",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.enableStreaming && _vm.sourceType !== "rtmp"
        ? _c(
            "div",
            { staticClass: "session-recorder__stream" },
            [
              _c(
                "ui-select",
                {
                  staticClass: "session-recorder__stream__select",
                  attrs: { label: "Stream" },
                  on: { open: _vm.getStreamList },
                  model: {
                    value: _vm.streamId,
                    callback: function ($$v) {
                      _vm.streamId = $$v
                    },
                    expression: "streamId",
                  },
                },
                _vm._l(_vm.streamList, function (streamItem) {
                  return _c("ui-select-item", {
                    key: streamItem.stream_id,
                    attrs: {
                      label: streamItem.title,
                      value: streamItem.stream_id,
                    },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.setDefaultStream(streamItem.stream_id)
                      },
                    },
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "ui-menu",
                {
                  attrs: {
                    icon: "fal fa-ellipsis-v fa-2x",
                    tooltip: "Stream actions",
                  },
                },
                [
                  _c("ui-menu-item", {
                    attrs: { icon: "fal fa-plus fa-fw", label: "Create new" },
                    on: { click: _vm.createStream },
                  }),
                  _vm._v(" "),
                  _c("ui-menu-item", {
                    attrs: {
                      disabled: !_vm.streamId,
                      icon: "fal fa-edit fa-fw",
                      label: "Edit",
                    },
                    on: { click: _vm.editStream },
                  }),
                  _vm._v(" "),
                  _c("ui-menu-item", {
                    attrs: {
                      disabled:
                        !_vm.streamId ||
                        Boolean(
                          _vm.sessionList.find(function (session) {
                            return session.stream_id === _vm.streamId
                          })
                        ),
                      icon: "fal fa-trash fa-fw",
                      label: "Delete",
                    },
                    on: { click: _vm.deleteStream },
                  }),
                  _vm._v(" "),
                  _c("ui-menu-item", {
                    attrs: {
                      disabled: !_vm.streamId,
                      icon: "fal fa-share fa-fw",
                      label: "Share",
                    },
                    on: { click: _vm.shareStream },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.sourceType === "rtmp"
        ? _c("rtmp-control", {
            staticClass: "session-recorder__rtmp",
            attrs: { recorder: _vm.recorder },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.sourceType === "video-conference"
        ? _c("sip-control", {
            staticClass: "session-recorder__video-conference",
            attrs: {
              "contact-list": _vm.contactList,
              "pending-contacts": _vm.pendingContacts,
              recorder: _vm.recorder,
              "session-list": _vm.sessionList,
              "stream-id": _vm.streamId,
            },
            on: {
              updatePendingContacts: function ($event) {
                return _vm.$emit("update:pendingContacts", $event)
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.sourceType === "skype-for-business"
        ? _c("skype-control", {
            staticClass: "session-recorder__skype-for-business",
            attrs: { recorder: _vm.recorder },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.sourceType === "webrtc"
        ? _c("web-rtc-control", {
            staticClass: "session-recorder__webrtc",
            attrs: {
              "session-list": _vm.sessionList,
              "stream-id": _vm.streamId,
              "stream-list": _vm.streamList,
              recorder: _vm.recorder,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("stream-create-dialog", {
        ref: "streamCreateDialog",
        on: {
          close: function ($event) {
            _vm.enableStreaming = Boolean(_vm.streamId)
          },
          create: _vm.createdStream,
        },
      }),
      _vm._v(" "),
      _c("stream-delete-dialog", {
        ref: "streamDeleteDialog",
        on: { delete: _vm.deletedStream },
      }),
      _vm._v(" "),
      _c("stream-edit-dialog", {
        ref: "streamEditDialog",
        on: { update: _vm.getStreamList },
      }),
      _vm._v(" "),
      _c("stream-share-dialog", { ref: "streamShareDialog" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }